<template>
	<div>
		<div class="edit-title" v-if="historyTitle && historyList.length > 0">{{ historyTitle }}</div>
		<div class="flexClass">
			<el-form-item v-for="(item, index) in historyList" :label="item.label" :key="index">
				<el-input placeholder="" v-model="item.value" disabled  class="widtdClass"></el-input>
				<!-- <div class="widtdClass" style="color: #787a7f">
					{{item.value || '--'}}
				</div> -->
			</el-form-item>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		historyTitle: {
			type: String,
			default: false
		},
		historyList: {
			type: Array,
			default: []
		}
	},
	data() {
		return {};
	},
	created() {
		// console.log(this.historyList);
	},
	watch: {},
	methods: {}
};
</script>

<style scoped lang="less">
.edit-title {
	padding: 15px;
}
.widtdClass {
	width: 200px;
}
.flexClass {
	width: 800px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}
</style>
